import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator";
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator";


export class Stkmf {
    @MaxLength(10,{message: 'COMPANY 字串太長'})
    @IsString({message: 'COMPANY 不是字串型態'})
    COMPANY: string = "";

    @MaxLength(10)
    CREATOR: string = "";

    @MaxLength(10)
    USR_GROUP: string = "";

    @MaxLength(8)
    CREATE_DATE: string ="";

    @MaxLength(10)
    MODIFIER: string = "";

    @MaxLength(8)
    MODI_DATE: string = "";

    @IsNumber()
    @Max(999)
    FLAG: number =0;


    @IsNotEmpty({message: '群組代號 (MF001) 不可空白'})
    @MaxLength(6,{message: '群組代號 (MF001) 資料太長'})
    MF001: string = '';            // 群組代號 6

    @IsNotEmpty({message: '股票代號 (MF002) 不可空白'})
    @MaxLength(10,{message: '股票代號 (MF002) 資料太長'})
    MF002: string = '';            // 股票代號 10

    @IsNumber()
    MF003: number = 99;            // 排序碼 4 [DEF:99]

    @MaxLength(1,{message: '更新碼 (MF004) 資料太長'})
    MF004: string = 'Y';            // 更新碼 1 [DEF:"Y"]

    @MaxLength(255,{message: '備註 (MF005) 資料太長'})
    MF005: string = '';            // 備註 255

    @MaxLength(8,{message: '更新日期 (MF006) 資料太長'})
    MF006: string = '';            // 更新日期 8


}
